export const resultsConstants = {
	GET_FINANCIALS_REQUEST: "GET_FINANCIALS_REQUEST",
	GET_FINANCIALS_SUCCESS: "GET_FINANCIALS_SUCCESS",
	GET_FINANCIALS_ERROR: "GET_FINANCIALS_ERROR",

	GET_BANK_BALANCES_REQUEST: "GET_BANK_BALANCES_REQUEST",
	GET_BANK_BALANCES_SUCCESS: "GET_BANK_BALANCES_SUCCESS",
	GET_BANK_BALANCES_ERROR: "GET_BANK_BALANCES_ERROR",
};
